import { render, staticRenderFns } from "./applyNatural.vue?vue&type=template&id=116909ce&scoped=true&"
import script from "./applyNatural.vue?vue&type=script&lang=js&"
export * from "./applyNatural.vue?vue&type=script&lang=js&"
import style0 from "./applyNatural.vue?vue&type=style&index=0&id=116909ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116909ce",
  null
  
)

export default component.exports